var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$route.path != '/livefacebook')?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('apexchart',{attrs:{"height":"500px","type":"line","options":_vm.chartOptions,"series":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }